import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class EventsHistoryAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = `/api/eventsHistory`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  getEventById(eventId, router){
    const url = `/api/eventsHistory/${eventId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(params, router) {
    const url = '/api/eventsHistory';
    return this.CommonAPIService.postCall(url, params, router);
  }

  delete(eventId, router) {
    const url = `/api/eventsHistory/${eventId}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(eventId, params, router) {
    const url = `/api/eventsHistory/${eventId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }
}
export default EventsHistoryAPIService;
